export interface ILinearFit {
  slope: number
  intercept: number
}

// Least-squares line over the defined points only (x = the value's index; null values are skipped).
// Undefined with fewer than 2 defined points, or when they all share one x.
export const linearFit = (values: (number | null)[]): ILinearFit | undefined => {
  const pts = values.flatMap((y, x) => (y === null ? [] : [{ x, y }]))
  if (pts.length < 2) {
    return undefined
  }
  const meanX = pts.reduce((sum, p) => sum + p.x, 0) / pts.length
  const meanY = pts.reduce((sum, p) => sum + p.y, 0) / pts.length
  const denominator = pts.reduce((sum, p) => sum + (p.x - meanX) ** 2, 0)
  if (denominator === 0) {
    return undefined
  }
  const slope = pts.reduce((sum, p) => sum + (p.x - meanX) * (p.y - meanY), 0) / denominator
  return { slope, intercept: meanY - slope * meanX }
}
